<vrm-card [cardTitle]='cardTitle' *ngIf='driverModules' [shadedHeaderLevel]='17'>
  <div class='vrm-card'>
    <div class='margin-10' *ngIf='driverModules.data.length === 0'>
      {{ 'GENERIC.noMentorPlaylistModules' | translate }}
    </div>

    <mat-accordion *ngIf='driverModules?.data != undefined' displayMode='flat'>
      <mat-expansion-panel
        class='vrm-summary-expansion no-elevation-but-underline'
        *ngFor='let moduleGroup of driverModules.data[0] | keyvalue'
      >
        <mat-expansion-panel-header>
          <div
            class='padding-t-5 margin-r-15 padding-l-5 bold'
            [style.font-size]="cService.isPcViewport ? '16px' : '70%'"
            [style.min-width]="cService.isPcViewport ? '100px' : '50px'"
          >
            {{ 'CHART.' + moduleGroup.key | translateOrFallback: moduleGroup.key }}
          </div>

          <div
            class='custom-chips-container'
            style='font-size: 85%'
            fxLayout='row'
            fxLayoutAlign='space-between'
          >
            <div
              *ngIf='moduleGroup.value.assigned != undefined'
              matTooltip="{{ moduleGroup.value.assigned }} {{ 'GENERIC.assigned' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ moduleGroup.value.assigned }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ moduleGroup.value.assigned }}</span
                >&nbsp;<span>{{ 'GENERIC.assigned' | translate }}</span>
							</span>
            </div>

            <div
              *ngIf='moduleGroup.value.completed != undefined'
              matTooltip="{{ moduleGroup.value.completed }} {{ 'GENERIC.completed' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ moduleGroup.value.completed }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ moduleGroup.value.completed }}</span
                >&nbsp;<span>{{ 'GENERIC.completed' | translate }}</span>
							</span>
            </div>

            <div
              *ngIf='moduleGroup.value.overdue != undefined'
              [class.red-color]='moduleGroup.value.overdue > 0'
              matTooltip="{{ moduleGroup.value.overdue }} {{ 'REPORTDATA.overDue' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ moduleGroup.value.overdue }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ moduleGroup.value.overdue }}</span
                >&nbsp;<span>{{ 'REPORTDATA.overDue' | translate }}</span>
							</span>
            </div>

            <div
              *ngIf='moduleGroup.value.assigned != undefined && moduleGroup.value.completed != undefined'
              [ngClass]='getNotStartedPhaseChipClass(moduleGroup.value)'
              matTooltip="{{ moduleGroup.value.notStarted }} {{ 'REPORTDATA.notStarted' | translate }}"
            >
              <span *ngIf='!cService.isPcViewport' class='bold'>{{ moduleGroup.value.notStarted }}</span>
              <span *ngIf='cService.isPcViewport'>
								<span class='bold'>{{ moduleGroup.value.notStarted }} </span>&nbsp;<span>{{
                'REPORTDATA.notStarted' | translate
                }}</span>
							</span>
            </div>
          </div>
        </mat-expansion-panel-header>

        <!-- Body - PC & Mobile -->
        <div *ngIf='moduleGroup.value.modules?.length'>
          <div *ngFor='let module of moduleGroup.value.modules'>
            <table class='raw-table'>
              <tr *ngIf='module?.courseName'>
                <td>{{ 'REPORTDATA.moduleName' | translate }}:</td>
                <td>
                  {{ module.courseName }}
                </td>
              </tr>

              <tr *ngIf='module?.assigned'>
                <td>{{ 'REPORTDATA.dateAssigned' | translate }}:</td>
                <td>{{ module.assigned | date: 'yyyy-MM-dd' }}</td>
              </tr>

              <tr *ngIf='module?.due'>
                <td>{{ 'REPORTDATA.dueDate' | translate }}:</td>
                <td>{{ module.due | date: 'yyyy-MM-dd' }}</td>
              </tr>

              <tr *ngIf='module?.datedone'>
                <td>{{ 'REPORTDATA.dateCompleted' | translate }}:</td>
                <td [class.red-text]='module?.overdue'>
                  {{ module.datedone | date: 'yyyy-MM-dd' }}
                </td>
              </tr>

              <tr *ngIf='module?.outcome'>
                <td *ngIf="module?.extraData?.isRoadRiskProfile || module?.extraData?.isRoadRiskDefensiveDriving">
                  {{ module.courseName }}
                  {{ 'REPORTCOLUMNS.Rating' | translate}}:
                </td>
                <td *ngIf="!module?.extraData?.isRoadRiskProfile && !module?.extraData?.isRoadRiskDefensiveDriving">
                  {{ 'REPORTDATA.status' | translate }}:
                </td>
                <td>
									<span class='bold' [ngClass]='getModuleDataClass(module.outcome)'>
                    {{ 'REPORTDATA.' + module.outcome.toLowerCase() | translateOrFallback: (module.outcome | titlecase) }}
									</span>
                </td>
              </tr>

              <tr *ngFor='let data of module.extraData | keyvalue: preserveOrder'>
                <ng-container *ngIf="!['isRoadRiskProfile', 'isRoadRiskDefensiveDriving'].includes(data.key)">
                  <td>{{ 'REPORTCOLUMNS.' + data.key | translateOrFallback: data.key }}:</td>
                  <td>
                    <span class='bold' [ngClass]='getModuleDataClass(data.value)' *ngIf="data.value">
                      {{ 'REPORTDATA.' + String(data.value).toLowerCase() | translateOrFallback: data.value }}
                    </span>
                  </td>
                </ng-container>
              </tr>
            </table>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</vrm-card>
